import { useRequestHeaders } from 'nuxt/app'
import { UAParser } from 'ua-parser-js'

declare module 'nuxt/app' {
  interface NuxtApp {
    $uaParser: UAParser
  }
}

export default defineNuxtPlugin({
  name: 'userAgentParser:plugin',
  setup() {
    const isServer = import.meta.server

    // 1) Безопасно получаем UA
    const userAgent = isServer
      ? (useRequestHeaders()?.['user-agent'] ?? '')
      : (globalThis?.navigator?.userAgent ?? '')

    // 2) Парсим один раз — этого достаточно как для SSR, так и на клиенте
    const uaParser = new UAParser(userAgent)

    return {
      provide: {
        uaParser,
      },
    }
  },
})
